/**
 * 官网打开App
 * https://rocflow.tech/app/?tartget=xxx
 */

export function openApp(deepLink: string) {
	if (typeof window === "undefined") return;
	window.location.href = getWebsiteUniversalLink(deepLink);
}

/**
 * 提取deeplink中的参数
 */

export function getDeepLinkParams(deepLink: string) {
	return deepLink.split("?target=")[1];
}

export function getWebsiteUniversalLink(url: string) {
	return "https://rockflow.tech/app/?target=" + url;
}

/**
 * TG 中使用外部浏览器打开
 * url 必须是https的链接， deeplink 不支持
 */
export function tgOpenLink(url: string) {
	if (typeof window === "undefined" || typeof window.Telegram === "undefined") return;
	window.Telegram.WebApp.openLink(url);
}
